<!-- eslint-disable -->
<template lang="pug">
    form.fields(action="javascript://", @submit="sendForm")
        .fields__element(v-if="user.isSuperadmin || user.type !== 'student'")
            label.fields__label.fields__label--small {{ $i18n.tc('fields.fields_school', 0) }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="schools",
                :show-labels="false",
                label="name",
                track-by="id",
                :searchable="true",
                :loading="loadingSchools",
                @open="getSchools",
                :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                v-model="form.school"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_schoolNotFound') }}
        .fields__element(v-if="user.isSuperadmin || user.type !== 'student'")
            label.fields__label {{ $i18n.tc('fields.fields_grade', 0) }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="grades",
                :show-labels="false",
                label="name",
                track-by="id",
                :loading="loadingGrades",
                :placeholder="gradesPlaceholder",
                v-model="form.grade",
                :disabled="isGradeDisabled",
                @open="getGrades"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_gradeNotFound') }}
        .fields__element(v-if="user.type !== 'student' && user.type !== 'olympiads-student'")
            label.fields__label.fields__label--small {{ $i18n.t('fields.fields_status') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="statuses",
                :show-labels="false",
                :allow-empty="false",
                :custom-label="getStatusName",
                placeholder="",
                v-model="form.status",
                :searchable="false"
            )
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_search') }}
            cs-search-input.fields__input(
                :placeholder="$i18n.t('fields.list_studentPlaceholder')",
                v-model="form.fullName"
                @search="sendForm"
            )
        .fields__element
            label.fields__label.fields__label--small {{ $i18n.t('fields.fields_period') }}
            cs-datepicker.fields__input.datepicker-input-container--no-margin(
                :language="user.locale",
                :disabled-dates="dateTo ? {from: new Date(dateTo)} : {}",
                v-model="dateFrom"
            )
            .fields__divider —
            cs-datepicker.fields__input.datepicker-input-container--no-margin(
                :language="user.locale",
                :disabled-dates="dateFrom ? {to: new Date(dateFrom)} : {}",
                v-model="dateTo"
            )
        .fields__element
            .fields__period-buttons-container
                a.fields__period-button(
                    v-for="periodValue in periods"
                    href="javascript://"
                    @click="setPeriod(periodValue)"
                )
                    | {{ $i18n.t(`fields.fields_${periodValue}Period`) }}
        .fields__element.fields__element--fluid
            cs-button(
                color="blue",
                pattern="primary-outline",
                html-tag="a"
                href="javascript://"
                @click="resetResults",
                narrow
            )
                | {{ $i18n.t('fields.fields_dropParameters') }}
</template>

<script>
    /*eslint-disable*/
    import searchFieldsMixin from '../../../utils/searchFieldsMixin';
    import { mapState } from 'vuex';
    import _ from 'lodash';
    import searchParamsStore from '../utils/searchParamsStore';
    import statusFieldMixin from '../utils/statusFieldMixin';
    import moment from 'moment';

    export default {
        props: ['schoolId', 'gradeId'],
        mixins: [searchFieldsMixin, searchParamsStore, statusFieldMixin],
        data () {
            return {
                schools: [],
                grades: [],
                form: {
                    school: null,
                    grade: null,
                    fullName: null,
                    date: null,
                    status: 'active',
                    dateFrom: null,
                    dateTo: null,
                },
                dateFrom: null,
                dateTo: null,
                requestSend: false,
                periods: ['day', 'week', 'month'],
            }
        },
        watch: {
            '$route.query' (val) {
                if (_.isEmpty(val)) {
                    this.form = _.cloneDeep(this.localSearchParams) || {
                        school: null,
                        grade: null,
                        student: null,
                        date: null,
                    };
                }
            },
            'form.school'() {
                this.updateList()
            },
            'form.grade'() {
                this.updateList()
            },
            'form.fullName' () {
                this.updateList()
            },
            'form.status' (val) {
                this.updateList();
            },
            'dateFrom' () {
                this.updateList()
            },
            'dateTo' () {
                this.updateList()
            },
        },
        methods: {
            sendForm () {
                if (this.dateFrom) {
                    this.form.dateFrom = moment(this.dateFrom).format('YYYY-MM-DD');
                }
                if (this.dateTo) {
                    this.form.dateTo = moment(this.dateTo).format('YYYY-MM-DD');
                }
                this.$emit('search', this.form);
                this.$nextTick(() => this.requestSend = false);
            },
            resetResults () {
                this.user.isSuperadmin && (this.form.school = null);
                this.form.grade = null;
                this.form.fullName = null;
                this.date = null;
                this.dateFrom = null;
                this.dateTo = null;
                this.form.status = 'active';
                this.$emit('search', this.form);
            },
            getStatusName (status) {
                return this.statusNames[status];
            },
            customFormatter (date) {
                return moment(date).format('D MMM YYYY');
            },
            setPeriod (range) {
                this.dateFrom = moment().startOf(range).format('YYYY-MM-DD');
                this.dateTo = moment().endOf(range).format('YYYY-MM-DD');
            },
            updateList: _.debounce(function() {
                this.sendForm()
            }, 1000)
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            })
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../assets/sass/fields/fields.scss";
</style>
